import SignIn from "../../slices/assets/SignIn";
import Sidebar from "../../slices/assets/Sidebar";

const assetsReducer = {
    signIn: SignIn,
    sidebar: Sidebar,
};

export default assetsReducer;